/* eslint-disable func-names */
/* eslint-disable new-cap */
import React from 'react';
import { pathOr, isNil, eqProps } from 'ramda';
import { Button, InputGroup, FormControl, Glyphicon } from 'react-bootstrap';
import connectToStores from 'alt-store-connect';
import { BaseStyle, ElementStyle } from '../../config/style';
import { connect } from 'react-redux';
import { addNotification } from '../../actions/reduxActions/notification';
import GraphConfig from '../../config/graph';
import { getElements } from '../../config/elements';
import GraphActions from '../../actions/graph';
import GraphStore from '../../stores/graph';
import GraphSource from '../../sources/graph';
import GraphUtils from '../../utils/graph';
import FlowActions from '../../actions/flow';
import customPopupMenu from './popupMenu';
import translations from '../../translations';
import { notificationTypes, MAP_ELEMENT_TYPES, keyCodes } from '../../constants';
import { isNullOrEmpty, getByID, generateRouteUrl, generateRandomString, safeToLower } from '../../utils/core';
import { navigate } from '@reach/router';
import '../../../css/flow/graph.less';
import '../../../css/notification.less';

import mxGraphFactory from 'mxgraph';
import { escapeHTML } from 'core-js/fn/string';

const {
    mxEdgeHandler,
    mxEditor,
    mxGraphHandler,
    mxKeyHandler,
    mxDefaultKeyHandler,
    mxVertexHandler,
    mxImage,
    mxUtils,
    mxPoint,
    mxEvent,
    mxRectangle,
    mxConstants,
    mxPanningHandler,
    mxElbowEdgeHandler,
    mxGraph,
    mxClipboard,
} = new mxGraphFactory();

const isSwimlaneOrGroup = cellStyle => (
    cellStyle.toLowerCase() === MAP_ELEMENT_TYPES.swimlane ||
    cellStyle.toLowerCase() === MAP_ELEMENT_TYPES.group
);

export const dropElementOntoGraph = (
    graphComponentInstance,
    elementType,
    flow,
    x, y,
    width,
    height,
    style,
    groupElementId,
) => {

    const {
        addElement,
        getGraph,
        onEditPage,
    } = graphComponentInstance;

    const {
        flowId,
        graph,
        tenantId,
        authenticationToken,
        openConfig,
    } = graphComponentInstance.props;

    const { configOptions } = graphComponentInstance;
    const element = getByID(elementType, getElements());

    if (!element.hasConfiguration) {

        // This is so that the return element does not
        // briefly disapear when dropped onto the canvas
        addElement('Return to Parent Flow', {
            flow,
            name: 'Return to Parent Flow',
        }, x, y, width, height, style, groupElementId);

        GraphSource.saveMapElement(
            {
                elementType,
                x,
                y,
                developerName: 'Return to Parent Flow',
                groupElementId,
            },
            flowId,
            graph.editingToken,
            'map',
            tenantId,
            authenticationToken,
        )
            .catch((error) => {
                graphComponentInstance.props.addNotification({
                    type: notificationTypes.ERROR,
                    message: error.message,
                    isPersistent: true,
                });
            })
            .then(getGraph);

        return;
    }

    addElement('temp', {
        flow,
        name: GraphConfig.newElementName,
        summary: GraphConfig.newElementSummary,
        pageId: '',
    }, x, y, width, height, style, groupElementId);

    const inputs = {
        id: '',
        flowId,
        editingToken: graph.editingToken,
        elementType,
        x,
        y,
        groupElementId,
    };

    const callbacks = [{
        execute: getGraph,
        type: 'done',
    }];

    if (manywho.utils.isEqual(style, 'input', true)) {
        callbacks.push({
            execute: onEditPage.bind(graphComponentInstance),
            type: 'forward',
            mapElement: '49bf23dc-ffb5-4ff8-9015-dbf3b6335f7c',
            repeat: true,
        });
    }

    openConfig(flow, inputs, callbacks, configOptions, null, element);
};

export const openConfigPanel = function (graph) {
    const selectedCell = graph.selectionModel.cells[0];
    const element = getElements().find(elem => eqProps('style', selectedCell, elem));

    if (
        element &&
        element.hasConfiguration &&
        selectedCell &&
        !manywho.utils.isEqual(selectedCell.style, 'start', true)
    ) {
        FlowActions.closeConfig(this.props.flowId);

        const inputs = {
            editingToken: this.props.graph.editingToken,
            flowId: this.props.flowId,
        };

        if (manywho.utils.isEqual(selectedCell.style, 'outcome', true)) {
            inputs.id = selectedCell.source.id;
            inputs.outcomeId = selectedCell.id;
            inputs.nextMapElementId = selectedCell.target.id;
        } else if (isSwimlaneOrGroup(selectedCell.style)) {
            inputs.id = selectedCell.id;
            inputs.elementType = selectedCell.style;
            inputs.x = selectedCell.geometry.x;
            inputs.y = selectedCell.geometry.y;
            inputs.width = selectedCell.geometry.width;
            inputs.height = selectedCell.geometry.height;
        } else {
            inputs.id = selectedCell.id;
            inputs.elementType = selectedCell.style;
            inputs.x = selectedCell.geometry.x;
            inputs.y = selectedCell.geometry.y;
        }

        this.setState({ highlighted: selectedCell.id });

        const callbacks = [{
            execute: this.getGraph,
            type: 'done',
        }];

        if (manywho.utils.isEqual(selectedCell.style, 'input', true)) {
            callbacks.push({
                execute: this.onEditPage.bind(this),
                type: 'forward',
                mapElement: '49bf23dc-ffb5-4ff8-9015-dbf3b6335f7c',
                repeat: true,
            });
        }

        this.props.openConfig(
            selectedCell.value.flow || selectedCell.style,
            inputs,
            callbacks,
            this.configOptions,
            selectedCell.id,
            element,
        );
    }
};

/**
 * Update the geometry, x,y coordinates of a Map Element
 *
 * @param {Array} graph props
 * @param {Object} movedCell the mxgraph cell object that was moved with the new target coordinates
 * @param {Array} mapElementsToSave updated list of Map Elements to be saved
 */
export const moveMapElement = (graph, movedCell, mapElementsToSave) => {
    let movedMapElement = graph.mapElements.find(element => element.id === movedCell.id);

    if (movedMapElement) {

        movedMapElement = JSON.parse(JSON.stringify(movedMapElement));

        // Make a note of the geometry change so we can move any manually placed
        // outcomes, i.e. those with a non-null controlPoint
        const diffX = movedCell.geometry.x - movedMapElement.x;
        const diffY = movedCell.geometry.y - movedMapElement.y;

        const sourceGroupElementId = movedMapElement.groupElementId;
        const targetGroupElementId = movedCell.parent && movedCell.parent.value && isSwimlaneOrGroup(movedCell.parent.style) ?
            movedCell.parent.id : null;

        movedMapElement.x = movedCell.geometry.x;
        movedMapElement.y = movedCell.geometry.y;

        if (movedMapElement.outcomes) {
            movedMapElement.outcomes = movedMapElement.outcomes.map((outcome) => {

                if (sourceGroupElementId !== targetGroupElementId) {
                    // When moving a Map Element in and out of Swimlanes the origin (0,0) of the coordinate system is based on the
                    // parent group. This gets very complicated with nested Swimlanes especially if a Map Element is moved from one
                    // nested Swimlane to another nested Swimlane. In order to calculate the different X,Y values in this case we would
                    // need to consider five different origins, which is possible, but it's highly unlikely that a manually positioned
                    // Outcome would make much sense in this case. In addition the control points for an Outcome uses the coordinate
                    // system of the destination Map Element - which could be in another Swimlane.
                    // Therefore we clear any manual positioning and let the Graph library do the right thing.

                    outcome.controlPoints = null;

                } else if (outcome.controlPoints) {
                    // Apply the geometry change to each outcome
                    outcome.controlPoints = outcome.controlPoints.map((controlPoint) => {
                        controlPoint.x += diffX;
                        controlPoint.y += diffY;
                        return controlPoint;
                    });
                }
                return outcome;
            });
        }

        // Now we need to identify any manually positioned Outcomes whose destination is the Map Element we are moving and
        // if the moved Map Element has changed Swimlanes. As noted above, the change in coordinate systems is painful to manage
        // so again, just reset the manually positioned inbound Outcomes.
        if (sourceGroupElementId !== targetGroupElementId) {

            // Check any already processed moved elements first
            const savedInboundMapElements = mapElementsToSave.filter(element => element.outcomes &&
                element.outcomes.find(outcome => outcome.nextMapElementId === movedCell.id));
            const inboundMapElements = graph.mapElements.filter(element => element.outcomes &&
                element.outcomes.find(outcome => outcome.nextMapElementId === movedCell.id));

            // De-dup the list of inboundMapElements retaining the modified candidates due to be saved.
            const ids = new Set(savedInboundMapElements.map(e => e.id));
            const merged = [...savedInboundMapElements, ...inboundMapElements.filter(e => !ids.has(e.id))];

            merged.forEach((inboundMapElement) => {
                // Reset any control points for Outcomes destined for the Map Element being moved.
                inboundMapElement.outcomes = inboundMapElement.outcomes.map((outcome) => {
                    if (outcome.nextMapElementId === movedCell.id) {
                        outcome.controlPoints = null;
                    }
                    return outcome;
                });

                mapElementsToSave.push(inboundMapElement);
            });
        }

        // Update the group membership if the element was moved between, or out of of a swimlane
        if (movedCell.parent && movedCell.parent.value && isSwimlaneOrGroup(movedCell.parent.style)) {
            movedMapElement.groupElementId = movedCell.parent.id;
        } else {
            movedMapElement.groupElementId = null;
        }

        mapElementsToSave.push(movedMapElement);
    }
};

/**
 * Update the geometry, x,y coordinates of a Group (swimlane) Element
 *
 * @param {Array} graph props
 * @param {Object} movedCell the mxgraph cell object that was moved with the new target coordinates
 * @param {Array} groupElementsToSave updated list of Swimlanes with new coordinates
 * @param {Array} mapElementsToSave updated list of Map Elements with new coordinates for their Outcomes. The coordinates of
 *                                  the Map Element are not changed, only the manually positioned Outcomes.
 */
export const moveGroupElement = (graph, movedCell, groupElementsToSave, mapElementsToSave) => {
    let groupElement = graph.groupElements.find(element => element.id === movedCell.id);

    if (groupElement) {
        groupElement = JSON.parse(JSON.stringify(groupElement));

        // Make a note of the geometry change so we can move any manually placed
        // outcomes, i.e. those with a non-null controlPoint
        const diffX = movedCell.geometry.x - groupElement.x;
        const diffY = movedCell.geometry.y - groupElement.y;

        groupElement.x = movedCell.geometry.x;
        groupElement.y = movedCell.geometry.y;

        // Update the group membership if the element was moved between, or out of of a swimlane
        if (movedCell.parent && movedCell.parent.value && isSwimlaneOrGroup(movedCell.parent.style)) {
            groupElement.groupElementId = movedCell.parent.id;
        } else {
            groupElement.groupElementId = null;
        }

        groupElementsToSave.push(groupElement);

        // Now we need to identify any Outcomes that have been manually positioned that leave this Group to a map element outside the Group.
        // This is necessary to ensure the coordinates of an Outcome also move in harmony with the parent swimlane.
        // Any Outcomes that are just within the group we can ignore as they are all positioned relative, just like any nested Groups etc.
        if (movedCell.children) {
            movedCell.children.forEach((child) => {

                if (child.connectable && !isSwimlaneOrGroup(child.style)) {

                    // Do any of these child Map Elements within our Group have a manually positioned Outcome that
                    // references a Map Element outside the current Group ?
                    const childrenToSave = graph.mapElements.filter(element => element.id === child.id &&
                        element.outcomes &&
                        element.outcomes.find(outcome => outcome.nextMapElementId &&
                            outcome.controlPoints &&
                            graph.mapElements.find(childElement => childElement.id === outcome.nextMapElementId &&
                                childElement.groupElementId !== groupElement.id)));

                    childrenToSave.forEach((childToSave) => {
                        // Apply the geometry change to each outcome
                        childToSave.outcomes = childToSave.outcomes.map((outcome) => {
                            outcome.controlPoints.map((controlPoint) => {
                                controlPoint.x += diffX;
                                controlPoint.y += diffY;
                                return controlPoint;
                            });
                            return outcome;
                        });

                        mapElementsToSave.push(childToSave);
                    });
                }
            });
        }

    }
};

/**
 * GraphInstances is used to store Graph component instances.
 * They are added as key value pairs when the component is mounted.
 * This is a workaround that is necessary for when we need to
 * prototype from mxGraph globals such as mxEdgeHandler.
 */

const GraphInstances = {};

mxEdgeHandler.prototype.changePoints = (edge, points) => {

    if (edge) {

        /**
         * This event is triggered for every mxGraph instance,
         * hence GraphInstances object.
         */

        Object.keys(GraphInstances).forEach((GraphInstanceId) => {
            const graph = GraphInstances[GraphInstanceId].graph.getModel();
            let edgeGeometry = graph.getGeometry(edge);

            if (edgeGeometry) {
                edgeGeometry = edgeGeometry.clone();
                edgeGeometry.points = points;
                graph.setGeometry(edge, edgeGeometry);
            }

            let mapElement = GraphInstances[GraphInstanceId].props.graph.mapElements.find(element => element.outcomes && element.outcomes.find(outcome => outcome.id === edge.id));

            if (mapElement) {
                mapElement = JSON.parse(JSON.stringify(mapElement));
                mapElement.outcomes = mapElement.outcomes.map((outcome) => {
                    if (outcome.id === edge.id) {
                        outcome.controlPoints = [{ x: points[0].x, y: points[0].y }];
                    }
                    return outcome;
                });

                GraphActions.save(
                    GraphInstances[GraphInstanceId].props.flowId,
                    [mapElement],
                    null,
                    GraphInstances[GraphInstanceId].props.tenantId,
                    GraphInstances[GraphInstanceId].props.authenticationToken,
                );
            }
        });
    }
};


/**
 * FUI-412: Moved the copying of the original `resizeCell` method out
 * of the Graph class/instances so it doesn't get duplicated multiple
 * times with multiple Graph instances and thus invoked multiple times.
 * This also fixed the 400 error when resizing the swimlane and sending
 * a request to `/api/draw/1/graph/flow` after switching tenants.
 */
const cellResizeHandler = mxVertexHandler.prototype.resizeCell;

@connectToStores
export class Graph extends React.Component {

    static getStores() {
        return [GraphStore];
    }

    static getPropsFromStores(props) {
        return {
            graph: GraphStore.getState().graphs[props.flowId],
            isLoading: GraphStore.getState().isLoading[props.flowId],
            isSaving: GraphStore.getState().isSaving[props.flowId],
            alert: GraphStore.getState().alert[props.flowId],
        };
    }

    constructor(props) {
        super(props);

        this.editor = new mxEditor();
        this.graph = this.editor.graph;
        this.graphHandlerMoveCells = mxGraphHandler.prototype.moveCells;
        this.keyHandler = new mxKeyHandler(this.graph, this.refs[props.flowId]);
        this.defaultKeyHandler = new mxDefaultKeyHandler(this.editor);
        this.isGroup = this.isGroup.bind(this);
        this.canConnectOutcome = this.canConnectOutcome.bind(this);
        this.setDefaultGraphOptions = this.setDefaultGraphOptions.bind(this);
        this.setDefaultGraphEvents = this.setDefaultGraphEvents.bind(this);
        this.getGraph = this.getGraph.bind(this);
        this.updateGraph = this.updateGraph.bind(this);
        this.filterMapElementsAndOutcomes = this.filterMapElementsAndOutcomes.bind(this);
        this.updateFilteredGraph = this.updateFilteredGraph.bind(this);
        this.addElement = this.addElement.bind(this);
        this.addOutcome = this.addOutcome.bind(this);
        this.getElementById = this.getElementById.bind(this);
        this.deleteMapElement = this.deleteMapElement.bind(this);
        this.onWheel = this.onWheel.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onFindChange = this.onFindChange.bind(this);
        this.closeFind = this.closeFind.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.onMoveCells = this.onMoveCells.bind(this);
        this.onGraphClick = this.onGraphClick.bind(this);
        this.onConnect = this.onConnect.bind(this);
        this.onConnectCell = this.onConnectCell.bind(this);
        this.onGraphDoubleClick = openConfigPanel.bind(this);

        this.debounceFilterMapElementsAndOutcomes = manywho.utils.debounce(this.filterMapElementsAndOutcomes, 750);

        this.state = { find: '', isFindVisible: false, highlighted: null, dragSources: null, newPageMoveDate: null };

        this.configOptions = {
            autofocusinput: true,
            outcomes: {
                isFixed: true,
            },
        };
    }

    componentDidMount() {
        GraphInstances[Object.keys(this.refs)[0]] = this;

        document.addEventListener('keyup', this.onKeyUp);
        document.addEventListener('keydown', this.onKeyDown);

        this.setDefaultGraphOptions();
        this.setDefaultGraphEvents();

        this.graph.connectionHandler.getConnectImage = cell => new mxImage(cell.style.portimage, 16, 16);

        ElementStyle.forEach((elementStyle) => {
            let style = null;

            if (elementStyle.hasBaseStyle) {
                style = $.extend({}, BaseStyle.style, elementStyle.style);
            } else {
                style = elementStyle.style;
            }

            const filteredStyle = $.extend({}, style, { opacity: 20 });
            const highlightedStyle = $.extend({}, style, { strokeColor: '#fdd835', strokeWidth: '5' });

            this.graph.getStylesheet().putCellStyle(`${elementStyle.name}_filtered`, filteredStyle);
            this.graph.getStylesheet().putCellStyle(`${elementStyle.name}_highlighted`, highlightedStyle);
            this.graph.getStylesheet().putCellStyle(elementStyle.name, style);
        });

        this.editor.setGraphContainer(this.refs[this.props.flowId]);

        const elements = [].slice.call(this.props.getDraggableElements());

        mxUtils.getOffset = (container, scrollOffset) => {
            let offsetLeft = 0;
            let offsetTop = 0;

            if (scrollOffset != null && scrollOffset) {
                const offset = mxUtils.getDocumentScrollOrigin(container.ownerDocument);
                offsetLeft += offset.x;
                offsetTop += offset.y;
            }

            const boundingRect = container.getBoundingClientRect();

            if (boundingRect != null) {
                offsetLeft += boundingRect.left;
                offsetTop += boundingRect.top;
            }

            return new mxPoint(offsetLeft, offsetTop);
        };

        this.setState({
            dragSources: elements.map((element) => {
                const elementConfig = getElements().filter(config => manywho.utils.isEqual(config.style, element.dataset.style, true))[0];
                const elementStyle = ElementStyle.filter(style => manywho.utils.isEqual(style.name, element.dataset.style, true))[0];
                const dragImageStyle = ElementStyle.filter(style => manywho.utils.isEqual(style.name, 'dragImage', true))[0];

                const dragImage = document.createElement('div');

                const view = this.graph.getView();
                const scale = view.getScale();

                if (isSwimlaneOrGroup(element.dataset.style)) {
                    const dragChild = document.createElement('div');
                    dragChild.classList.add(`${element.dataset.style}-child`);
                    dragImage.classList.add(`${element.dataset.style}-parent`);
                    dragChild.setAttribute('style', `left: -${60 * scale}'px; top: ${65 * scale}'px; font-size: ${14 * scale}px;`);
                    dragImage.appendChild(dragChild);
                } else {
                    const dragIcon = document.createElement('span');
                    const dragText = document.createElement('span');
                    dragIcon.classList.add('glyphicon', `glyphicon-${elementConfig.icon}`);
                    dragText.innerHTML = ` ${elementConfig.name}`;
                    dragIcon.setAttribute('style', `margin-top: ${20 * scale}'px; margin-left: ${15 * scale}'px;`);
                    dragText.setAttribute('style', `margin-top: ${20 * scale}'px; margin-left: ${5 * scale}'px; font-size: ${14 * scale}px`);
                    dragImage.appendChild(dragIcon);
                    dragImage.appendChild(dragText);

                    for (const property in dragImageStyle.style) dragImage.style[property] = dragImageStyle.style[property];

                    dragImage.style.background = elementConfig.background;
                }

                dragImage.classList.add('grabbing', 'mw-bs');
                dragImage.dataset.style = elementConfig.style;
                dragImage.dataset.flow = elementConfig.flow;
                dragImage.dataset.elementid = elementConfig.id;

                dragImage.style['margin-left'] = `-${elementStyle.size.width / 2}px`;
                dragImage.style['margin-top'] = `-${elementStyle.size.height / 2}px`;

                dragImage.style.width = `${elementStyle.size.width}px`;
                dragImage.style.height = `${elementStyle.size.height}px`;

                const draggableElement = mxUtils.makeDraggable(element, this.graph, this.onDrop(elementConfig), dragImage, 0, 0, true, true);

                draggableElement.createPreviewElement = (graph) => {
                    const previewElement = dragImage.cloneNode(true);
                    const previewScale = graph.view.scale;

                    mxUtils.setPrefixedStyle(previewElement.style, 'transform', `scale(${previewScale},${previewScale})`);
                    mxUtils.setPrefixedStyle(previewElement.style, 'transformOrigin', 'top left');

                    return previewElement;
                };

                draggableElement.dragOffset.y = 0;
                draggableElement.setGuidesEnabled(true);

                return draggableElement;
            }),
        });

        if (this.props.graph) this.updateGraph();

        this.props.onGetUpdate(this.updateGraph);
    }

    componentDidUpdate(prevProps) {

        // This is to prevent the copy/paste pop up menu
        // from persisting when switching between Flow tabs
        if (!this.props.isActive && this.graph.popupMenuHandler.containsItems) {
            this.graph.popupMenuHandler.hideMenu();
        }

        if (!prevProps.alert && this.props.alert) {
            const alertMessage = pathOr(null, ['alert', 'message', 'message'], this.props) ||
                pathOr(null, ['alert', 'message'], this.props);

            const alertType = {
                default: notificationTypes.INFO,
                primary: notificationTypes.SUCCESS,
                success: notificationTypes.SUCCESS,
                info: notificationTypes.INFO,
                warning: notificationTypes.WARNING,
                danger: notificationTypes.ERROR,
            };

            if (!isNullOrEmpty(alertMessage)) {
                this.props.addNotification({
                    type: alertType[this.props.alert.style],
                    message: alertMessage,
                    isPersistent: true,
                });
            }
        }

        if ((this.props.graph && !prevProps.graph) || (prevProps.isLoading && !this.props.isLoading) || (prevProps.isSaving && !this.props.isSaving) || (!prevProps.alert && this.props.alert)) {
            customPopupMenu(
                this.graph,
                this.props.flowId,
                this.props.tenantId,
                this.props.graph.editingToken,
                this.props.authenticationToken,
                this.props.addNotification,
            );
            this.updateGraph();
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeyDown);
        document.removeEventListener('keyup', this.onKeyUp);
        this.graph.connectionHandler.destroy();
        this.graph.destroy();

        // Remove the instance from GraphInstances object when tab closes
        delete GraphInstances[Object.keys(this.refs)[0]];
    }

    /**
     * Handle moving elements on the canvas.
     *
     * Even though we have a 'tree' structure with parent and child relationships between
     * Group Elements, we don't need a recursive algorithm because all positioning is relative, so
     * any contained child elements can retain their original coordinates.
     *
     * @param {Object} graph the mxgraph instance
     * @param {Object} event the move event containing the list of moved cells
     */
    onMoveCells(graph, event) {
        const cells = event.getProperty('cells');

        if (cells) {
            const mapElementsToSave = [];
            const groupElementsToSave = [];

            // Note that the list of moved cells does not include any children of groups
            cells.forEach((movedCell) => {
                if (isSwimlaneOrGroup(movedCell.style)) {
                    moveGroupElement(this.props.graph, movedCell, groupElementsToSave, mapElementsToSave);
                } else {
                    moveMapElement(this.props.graph, movedCell, mapElementsToSave);
                }
            });

            GraphActions.save(this.props.flowId, mapElementsToSave, groupElementsToSave, this.props.tenantId, this.props.authenticationToken);
        }
    }

    // Callback attached to "Map Element Page" System Flow
    // Gets called whenever UI reaches the "Page Details" map element
    // Reads components on the page to know what the user did last,
    // and opens a new Page Editor when needed
    onEditPage(callback, response) {
        // In "Map Element Page" a value called "Command" is set various values so we know what the user just did
        // "Command" is attached to a hidden component called "Hidden Command" on the "Page Details" page only because we read it here
        // In this callback, we only deal with "Edit" and "New"
        // --New--
        // Command is set to "New" when the user clicks "New Page Layout"
        // The Flow then creates a page, makes it selected in the Dropdown, sets "Command" to "New" and returns to the "Page Details" page
        // Then this is triggered and we should open a Page Editor for the new page
        // --Edit--
        // Command is set to "Edit" when the user clicks "Edit Page Layout"
        // The Flow then sets "Command" to "Edit" and returns to the "Page Details" page
        // Then this is triggered and we should open a Page Editor for the selected page
        const command = GraphUtils.getComponentDataFromResponse('Hidden Command', response).contentValue;
        const newDate = GraphUtils.getComponentDataFromResponse('UserLastEditNewDate', response).contentValue;

        // In "Map Element Page", we purposefully only update the Date value called "UserLastEditNewDate"
        // when a user clicks "Edit Page Layout"/"New Page Layout"
        // Thus if for any other reason the page refreshes and the command is somehow still "Edit"/"New", we shouldn't actually create/edit a page
        // These scenarios include:
        // Possibly another outcome from the Page Editor returning without nulling "Command"
        //      (All other paths do null "Command" now though)
        // Validation failure which reloads the page with the same Values in the page components
        //      (Such a failure can happen when trying to save the page map element without a name)
        if (isNullOrEmpty(command) === false && newDate !== this.state.newPageMoveDate) {
            // Save this Date so that it cannot be re-given to us and incorrectly create/edit a page
            this.setState({ newPageMoveDate: newDate });
            // Take the page the user has Selected from the UI
            // Or for a new page, take it from this because we update this component with the newly made page
            const pageElement = GraphUtils.getComponentDataFromResponse('Select Page', response).objectData;
            const selectedPageId = manywho.utils.getObjectDataProperty(pageElement[0].properties, 'Id').contentValue;
            const selectedPageName = manywho.utils.getObjectDataProperty(pageElement[0].properties, 'DeveloperName').contentValue;

            if (command.toLowerCase() === 'new') {
                // Open the newly made page in a tab
                const route = generateRouteUrl({
                    tabType: 'new_page',
                    tenantId: this.props.tenantId,
                    options: {
                        tabKey: generateRandomString(16),
                        pageName: selectedPageName,
                        pageId: selectedPageId,
                    },
                });
    
                navigate(route);
            }
            if (command.toLowerCase() === 'edit') {
                if (isNullOrEmpty(selectedPageId)) {
                    // User tried to edit a page without selecting one first
                    this.props.addNotification({ type: 'error', message: translations['edit page with none selected'], isPersistent: true });
                } else {
                    // Open the selected page in a tab
                    const route = generateRouteUrl({
                        tabType: 'page',
                        tenantId: this.props.tenantId,
                        options: {
                            pageId: selectedPageId,
                        },
                    });
        
                    navigate(route);
                }
            }
        }
    }

    onGraphDoubleClick(graph) {
        const selectedCell = graph.selectionModel.cells[0];

        if (
            selectedCell
            && !manywho.utils.isEqual(selectedCell.style, 'start', true)
        ) {
            FlowActions.closeConfig(this.props.flowId);

            const inputs = {
                editingToken: this.props.graph.editingToken,
                flowId: this.props.flowId,
            };

            if (manywho.utils.isEqual(selectedCell.style, 'outcome', true)) {
                inputs.id = selectedCell.source.id;
                inputs.outcomeId = selectedCell.id;
                inputs.nextMapElementId = selectedCell.target.id;
            } else if (isSwimlaneOrGroup(selectedCell.style)) {
                inputs.id = selectedCell.id;
                inputs.elementType = selectedCell.style;
                inputs.x = selectedCell.geometry.x;
                inputs.y = selectedCell.geometry.y;
                inputs.width = selectedCell.geometry.width;
                inputs.height = selectedCell.geometry.height;
            } else {
                inputs.id = selectedCell.id;
                inputs.elementType = selectedCell.style;
                inputs.x = selectedCell.geometry.x;
                inputs.y = selectedCell.geometry.y;
            }

            this.setState({ highlighted: selectedCell.id });

            const callbacks = [{
                execute: this.getGraph,
                type: 'done',
            }];

            if (manywho.utils.isEqual(selectedCell.style, 'input', true)) {
                callbacks.push({
                    execute: this.onEditPage.bind(this),
                    type: 'forward',
                    mapElement: '49bf23dc-ffb5-4ff8-9015-dbf3b6335f7c',
                    repeat: true,
                });
            }

            this.props.openConfig(
                selectedCell.value.flow || selectedCell.style,
                inputs,
                callbacks,
                this.configOptions,
                selectedCell.id,
            );
        }
    }

    onGraphClick(graph, event) {
        const { cell } = event.properties;

        // By default, when clicking a map element that's in a group
        // the selection cycles between the map element and nesting groups with each click
        // This is undesirable because when double clicking to open the config panel
        // the selection is cycling between the nesting groups and map element.
        // It's also confusing that simply clicking a map element makes different selections.
        if (!isNil(cell) && graph.selectionModel.cells.length === 1) {

            // If the now selected element is not the clicked element
            // and only a single element is selected,
            // force the clicked element to be selected instead,
            // overriding the mxGraph default selection cycling behaviour.

            graph.setSelectionCell(cell);
        }

        if (cell
            && event.properties.event.shiftKey
            && !event.properties.event.ctrlKey
            && !manywho.utils.isEqual(cell.style, 'outcome')) {
            const elementType = (isSwimlaneOrGroup(cell.style)) ? 'group' : 'map';
            this.props.setSelectedMapElement(cell.id, elementType);
            return;
        }

        if (cell && event.properties.event.ctrlKey) {
            const mapElement = this.props.graph.mapElements.filter(item => item.id === cell.id)[0];
            let filteredMapElements = [];
            let filteredOutcomes = [];

            if (mapElement && mapElement.outcomes) {
                let connectedElements = [mapElement.id];

                if (event.properties.event.shiftKey) {
                    connectedElements = connectedElements.concat(this.getConnectedMapElements(mapElement.outcomes, []));
                } else {
                    connectedElements = connectedElements.concat(mapElement.outcomes.map(outcome => outcome.nextMapElementId));
                }

                filteredMapElements = this.props.graph.mapElements.filter(element => connectedElements.indexOf(element.id) === -1);
                filteredOutcomes = [].concat.apply([], filteredMapElements.map(element => element.outcomes || []))
                    .map(outcome => outcome.id);

                filteredMapElements = filteredMapElements.map(element => element.id);
            }

            this.updateFilteredGraph(filteredMapElements, filteredOutcomes);
        } else if (!cell) {
            this.updateFilteredGraph(null, null);
        }
    }

    onConnect(graph, event) {
        const inputs = {
            id: event.properties.cell.source.id,
            targetId: event.properties.cell.target.id,
            flowId: this.props.flowId,
            editingToken: this.props.graph.editingToken,
            nextMapElementId: event.properties.target.id,
        };
        this.props.openConfig('outcome', inputs, [{ execute: this.getGraph, type: 'done' }], { autofocusinput: true });
    }

    onConnectCell(graph, event) {
        if (event.properties.source) {
            event.properties.edge.source = event.properties.previous;
            return false;
        }

        if (event.properties.previous) {
            const inputs = {
                id: event.properties.edge.source.id,
                outcomeId: event.properties.edge.id,
                previousId: event.properties.previous.id,
                targetId: event.properties.edge.target.id,
                flowId: this.props.flowId,
                editingToken: this.props.graph.editingToken,
            };
            this.props.openConfig('Outcome Redirect', inputs, [{ execute: this.getGraph, type: 'done' }], { autofocusinput: true });
        }

        return true;
    }

    onClick(event) {
        // Reset zoom on triple click
        if (event.nativeEvent.detail === 3) {
            this.graph.zoomTo(1, true);
        }
    }

    onKeyDown(e) {

        const isCtrlKey = e.ctrlKey || e.keyCode === 91 || e.keyCode === 93;
        const isAltKey = e.altKey;

        if (this.props.isActive && !this.props.isLoading && !this.props.disabled) {
            // CTRL + ALT + C: copying a map element
            if (e.keyCode === 67 && isCtrlKey && isAltKey) {
                // if no selection don't do anything
                const selectedCells = this.graph.getSelectionCells();
                if (selectedCells.length === 0) {
                    return;
                }
                // cannot copy start or outcomes so filter
                const filteredCells = selectedCells.filter(
                    element => (element.style !== 'start') && (element.style !== 'outcome'),
                );
                // if there is any take the first one and copy as paste doesn't
                // support multiple cells from the clipboard (mxClipboard does)
                if (filteredCells && filteredCells.length > 0) {
                    mxClipboard.setCells(filteredCells[0]);
                    this.props.addNotification({
                        type: 'success',
                        message: `Copied ${filteredCells[0].value.name} to clipboard`,
                        isPersistent: false,
                    });
                } else {
                    this.props.addNotification({
                        type: 'error',
                        message: translations['copy start-outcome error'],
                        isPersistent: false,
                    });
                }
            }

            // CTRL + ALT + V: pasting a map element
            if (e.keyCode === 86 && isCtrlKey && isAltKey) {
                GraphUtils.duplicateMapElement(
                    this.props.flowId,
                    this.props.tenantId,
                    this.props.graph.editingToken,
                    this.props.authenticationToken,
                    this.props.addNotification,
                    null,
                    null,
                    mxClipboard,
                );
            }

            // CTRL + F
            if (e.keyCode === 70 && isCtrlKey) {
                this.setState({ isFindVisible: true });
                e.preventDefault();
                return false;
            }

            // CTRL + P
            if (e.keyCode === 80 && isCtrlKey) {
                e.preventDefault();
                GraphSource.getMapElements(this.props.flowId, this.props.graph.editingToken, this.props.tenantId, this.props.authenticationToken)
                    .then(response => GraphUtils.printGraph(
                        this.props.graph.developerName,
                        this.props.graph.dateModified,
                        this.props.graph.developerSummary,
                        response,
                        this.props.flowId,
                        this.props.graph.editingToken,
                        this.props.tenantId,
                        this.props.authenticationToken,
                    ));
            }
            // ESC
            if (e.keyCode === 27 && this.state.isFindVisible) {
                this.closeFind();
                e.preventDefault();
                return false;
            }
            // SHIFT + F
            if (e.shiftKey && e.keyCode === 70) {
                this.graph.fit();
            }
        }

        return true;
    }

    onDrop({ flow, style }) {

        return (graph, event, cell, x, y) => {
            event.preventDefault();

            const elementStyle = ElementStyle.filter(elementStyle => manywho.utils.isEqual(elementStyle.name, style))[0];

            const { width, height } = elementStyle.size;

            let mapElementX = 0;
            let mapElementY = 0;
            let groupElementId = '';

            if (cell && isSwimlaneOrGroup(cell.style)) {
                mapElementX = parseInt((x - width / 2) - cell.geometry.x, 10);
                mapElementY = parseInt((y - height / 2) - cell.geometry.y, 10);
                groupElementId = cell.id;
            } else {
                mapElementX = parseInt(x - width / 2, 10);
                mapElementY = parseInt(y - height / 2, 10);
            }

            dropElementOntoGraph(this, style, flow, mapElementX, mapElementY, width, height, elementStyle.name, groupElementId);
        };
    }

    onKeyUp(event) {
        // DELETE
        if (event.keyCode === keyCodes.DELETE &&
            this.graph.getSelectionCells().length > 0 &&
            this.props.isActive &&
            !this.props.disabled &&
            !this.props.isMetadataVisible
        ) {
            this.deleteMapElement();
        }
    }

    onWheel(event) {
        event.preventDefault();

        const view = this.graph.getView();
        const scale = view.getScale();

        if ((event.nativeEvent.wheelDelta > 0 || event.nativeEvent.deltaY < 0) && scale < 1.7) {
            this.graph.zoomIn();
        } else if ((event.nativeEvent.wheelDeltaY < 0 || event.nativeEvent.deltaY > 0) && scale > 0.55) {
            this.graph.zoomOut();
        }
    }

    onFindChange(e) {
        this.setState({ find: e.target.value });
        this.debounceFilterMapElementsAndOutcomes(e.target.value);
    }

    setDefaultGraphEvents() {
        this.graph.addListener(mxEvent.MOVE_CELLS, this.onMoveCells);
        this.graph.addListener(mxEvent.DOUBLE_CLICK, this.onGraphDoubleClick);
        this.graph.addListener(mxEvent.CLICK, this.onGraphClick);
        this.graph.connectionHandler.addListener(mxEvent.CONNECT, this.onConnect);
        this.graph.addListener(mxEvent.CONNECT_CELL, this.onConnectCell);

        const self = this;

        mxVertexHandler.prototype.resizeCell = function (cell) {
            cellResizeHandler.apply(this, arguments);

            let groupElement = null;

            if (self.props.graph.groupElements) {
                groupElement = self.props.graph.groupElements.find(element => element.id === cell.id);
            }

            if (groupElement) {
                groupElement = JSON.parse(JSON.stringify(groupElement));
                groupElement.width = cell.geometry.width;
                groupElement.height = cell.geometry.height;
            }

            GraphActions.save(self.props.flowId, null, [groupElement], self.props.tenantId, self.props.authenticationToken);
        };

        // CTRL + A
        this.defaultKeyHandler.bindAction(65, 'selectAll', 1);
    }

    setDefaultGraphOptions() {
        const self = this;

        function mxVertexToolHandler(state) {
            mxVertexHandler.apply(this, arguments);
        }

        mxVertexToolHandler.prototype = new mxVertexHandler();
        mxVertexToolHandler.prototype.constructor = mxVertexToolHandler;

        mxVertexToolHandler.prototype.domNode = null;

        mxVertexToolHandler.prototype.init = function () {
            mxVertexHandler.prototype.init.apply(this, arguments);

            if (this.state.cell.style !== 'start') {

                this.domNode = document.createElement('div');
                this.domNode.style.position = 'absolute';
                this.domNode.style.whiteSpace = 'nowrap';

                // Generate a delete icon
                self.createMapElementIcons(
                    'https://assets.manywho.com/draw/img/delete.png',
                    'delete',
                    self.deleteMapElement,
                    this.domNode,
                );

                this.graph.container.appendChild(this.domNode);
                this.redrawTools();
            }
        };

        mxVertexToolHandler.prototype.redraw = function redraw() {
            mxVertexHandler.prototype.redraw.apply(this);
            this.redrawTools();
        };

        mxVertexToolHandler.prototype.redrawTools = function redrawTools() {
            if (this.state != null && this.domNode != null) {
                this.domNode.style.left = `${(this.state.x + this.state.width - 15)}px`;
                this.domNode.style.top = `${(this.state.y - 29)}px`;
            }
        };

        mxVertexToolHandler.prototype.destroy = function destroy(sender, me) {
            mxVertexHandler.prototype.destroy.apply(this, arguments);

            if (this.domNode != null) {
                this.domNode.parentNode.removeChild(this.domNode);
                this.domNode = null;
            }
        };

        const graphWidth = GraphConfig.graphWidth || this.refs[this.props.flowId].clientWidth;
        const graphHeight = GraphConfig.graphHeight || this.refs[this.props.flowId].clientHeight;

        this.graph.maximumContainerSize = new mxRectangle(0, 0, graphWidth, graphHeight);
        this.graph.minimumContainerSize = new mxRectangle(0, 0, graphWidth, graphHeight);

        // Will need to review all of these options to make sure what we want to make configurable
        this.graph.setCellsResizable(true);
        this.graph.setAutoSizeCells(true);
        this.graph.setCellsEditable(false);
        this.graph.setEdgeLabelsMovable(false);
        this.graph.setConnectable(true);
        this.graph.setAllowDanglingEdges(false);
        this.graph.setTooltips(true);
        this.graph.setAllowLoops(false);
        this.graph.setDropEnabled(true);
        this.graph.setSplitEnabled(false);
        this.graph.edgeLabelsMovable = false;
        this.graph.htmlLabels = true;
        this.graph.keepEdgesInBackground = true;
        this.graph.connectionHandler.targetConnectImage = true;
        this.graph.constrainChildren = true;
        this.graph.defaultOverlap = 0;
        this.graph.zoomFactor = 1.05;

        this.graph.cellLabelChanged = (cell, newValue, autoSize) => {
            autoSize = true;
            this.apply(this, arguments);
        };

        this.graph.convertValueToString = cell => cell.value.name;
        this.graph.getTooltipForCell = cell => cell.value.summary;
        this.graph.isValidDropTarget = this.isGroup;

        // Set as to whether the cell having an outcome dragged
        // from it is a valid outcome source
        this.graph.connectionHandler.isValidSource = cell => this.canConnectOutcome(cell, true);

        // Set as to whether the cell having an outcome dragged
        // to it is a valid outcome target
        this.graph.connectionHandler.isValidTarget = cell => this.canConnectOutcome(cell, false);

        this.graph.getTooltipForCell = cell => cell.value.label;

        this.graph.createHandler = function (state) {
            if (state != null &&
                this.model.isVertex(state.cell)) {
                return new mxVertexToolHandler(state);
            }

            return mxGraph.prototype.createHandler.apply(this, arguments);
        };

        mxConstants.MIN_HOTSPOT_SIZE = 16;
        mxConstants.DEFAULT_HOTSPOT = 1;

        const options = {};

        options.HIGHLIGHT_COLOR = '#66bb6a';
        options.VERTEX_SELECTION_COLOR = '#DFF0D8';
        options.EDGE_SELECTION_COLOR = '#DFF0D8';
        options.SHADOWCOLOR = '#C0C0C0';

        mxGraphHandler.prototype.guidesEnabled = true;
        mxPanningHandler.prototype.useLeftButtonForPanning = GraphConfig.leftButtonForPanning;
        mxPanningHandler.prototype.setPinchEnabled(true);
        mxElbowEdgeHandler.prototype.getTooltipForNode = () => 'Drag to change the outcome position.';

        const mxPanningHandlerMouseDown = mxPanningHandler.prototype.mouseDown;
        mxPanningHandler.prototype.mouseDown = function (sender, me) {
            if (!mxEvent.isControlDown(me.evt) && me.evt.button != 2) {
                mxPanningHandlerMouseDown.apply(this, arguments);
            }
        };

        $.extend(mxConstants, options);
    }

    getConnectedMapElements(outcomes, filteredElements) {
        let mapElements = filteredElements;
        if (outcomes) {
            outcomes.forEach((outcome) => {
                if (outcome.nextMapElementId && filteredElements.indexOf(outcome.nextMapElementId) == -1) {
                    mapElements.push(outcome.nextMapElementId);

                    const mapElement = this.props.graph.mapElements.filter(item => item.id === outcome.nextMapElementId)[0];
                    if (mapElement) {
                        mapElements = this.getConnectedMapElements(mapElement.outcomes, filteredElements);
                    }
                }
            });
        }
        return mapElements;
    }

    getGraph() {
        this.setState({ highlighted: null });
        GraphActions.get(this.props.flowId, this.props.tenantId, this.props.authenticationToken);
    }

    getElementById(id) {
        return this.graph.getModel().getCell(id);
    }

    isGroup(cell) {
        if (cell && this.props.graph.groupElements) {
            return this.props.graph.groupElements.filter(element => manywho.utils.isEqual(cell.id, element.id, true)).length > 0;
        }

        return false;
    }

    /**
     *
     * @param {Object} cell mxGraph object that describes a graph element
     * @param {Boolean} isSourceElement determines whether or not the cell is the source of the handler
     * @description Determine whether an outcome can be connected to the specified cell
     */
    canConnectOutcome(cell, isSourceElement) {
        const mapElement = getByID(cell.style, getElements());

        // If the cell is being targeted for an outcome and has no map element config
        // e.g. is a return element, then we want to return false
        if (cell && this.props.graph.mapElements && (!isSourceElement || mapElement.hasConfiguration)) {
            return this.props.graph.mapElements.some(element => manywho.utils.isEqual(
                cell.id, element.id, true,
            ));
        }

        return false;
    }

    updateGraph() {
        this.graph.removeCells(this.graph.getChildVertices(this.graph.getDefaultParent()));

        this.graph.getModel().beginUpdate();

        try {
            // Add swimlanes first
            this.props.graph.groupElements && this.props.graph.groupElements.forEach((groupElement) => {
                const value = {
                    name: groupElement.developerName,
                    summary: groupElement.developerSummary,
                    flow: getElements().filter(element => manywho.utils.isEqual(element.style, groupElement.elementType, true))[0].flow,
                };
                this.addElement(groupElement.id, value, groupElement.x, groupElement.y, groupElement.width, groupElement.height, groupElement.elementType, groupElement.groupElementId);
            });

            // Add the map elements before the outcomes
            this.props.graph.mapElements.filter(e => safeToLower(e.elementType) !== MAP_ELEMENT_TYPES.note).forEach((mapElement) => {
                const style = ElementStyle.filter(element => manywho.utils.isEqual(element.name, mapElement.elementType, true))[0];
                const value = {
                    name: escapeHTML(mapElement.developerName),
                    summary: mapElement.developerSummary,
                    pageId: mapElement.pageElementId,
                    flow: getElements().filter(element => manywho.utils.isEqual(element.style, mapElement.elementType, true))[0].flow,
                };
                this.addElement(
                    mapElement.id,
                    value,
                    mapElement.x,
                    mapElement.y,
                    style.size.width,
                    style.size.height,
                    'base' ? mapElement.elementType : 'base',
                    mapElement.groupElementId,
                );
            });

            // Add outcomes
            this.props.graph.mapElements.forEach((mapElement) => {
                if (mapElement.outcomes && mapElement.outcomes.length > 0) {
                    mapElement.outcomes.forEach((outcome) => {
                        const value = {
                            name: escapeHTML(outcome.developerName),
                            label: outcome.label,
                            id: outcome.id,
                        };
                        this.addOutcome(
                            outcome.id,
                            value,
                            this.getElementById(mapElement.id),
                            this.getElementById(outcome.nextMapElementId),
                            'outcome',
                            mapElement.grouupElementId,
                            outcome.controlPoints,
                        );
                    });
                }
            });
        } finally {
            this.graph.getModel().endUpdate();
        }

        this.props.graph.mapElements.filter(e => safeToLower(e.elementType) !== MAP_ELEMENT_TYPES.note).forEach((mapElement) => {
            const state = this.graph.view.getState(this.graph.getModel().getCell(mapElement.id));

            if (mapElement.elementType === 'START') {
                state.shape.node.id = 'start-map-element';
            } else {
                state.shape.node.id = `shape-${mapElement.id}`;
                state.text.node.id = `label-${mapElement.id}`;
            }

            if (mapElement.outcomes && mapElement.outcomes.length > 0) {
                mapElement.outcomes.forEach((outcome) => {
                    const cell = this.graph.view.getState(this.graph.getModel().getCell(outcome.id));
                    if (cell) {
                        cell.shape.node.id = outcome.id;
                    }
                });
            }
        });
    }

    addElement(id, value, x, y, width, height, style, parent) {
        let elementParent = this.graph.getDefaultParent();

        if (parent && parent !== '') {
            elementParent = this.graph.getModel().getCell(parent);
        }

        return this.graph.insertVertex(elementParent, id, value, x, y, width, height, style.toLowerCase());
    }

    addOutcome(id, value, source, target, style, parent, controlPoints) {
        let elementParent = this.graph.getDefaultParent();

        if (parent && parent !== '') {
            elementParent = this.graph.getModel().getCell(parent);
        }

        this.graph.insertEdge(elementParent, id, value, source, target, style);

        if (controlPoints && controlPoints.length > 0) {
            const model = this.graph.getModel();
            const edge = model.getCell(id);
            let edgeGeometry = model.getGeometry(edge);
            if (edgeGeometry) {
                edgeGeometry = edgeGeometry.clone();
                edgeGeometry.points = controlPoints.map(controlPoint => new mxPoint(controlPoint.x, controlPoint.y));
                model.setGeometry(edge, edgeGeometry);
            }
        }
    }

    deleteMapElement() {
        const selectedCell = this.graph.getSelectionCells()[0];

        if (selectedCell.style === 'start') {
            return false;
        }

        const elementConfig = getElements();
        const cellConfig = elementConfig.filter(element => manywho.utils.isEqual(element.style, selectedCell.style))[0];

        const inputs = {
            editingToken: this.props.graph.editingToken,
            flowId: this.props.flowId,
        };

        if (cellConfig.isGroupCell) {
            inputs.id = selectedCell.id;
            inputs.elementType = selectedCell.style;
            this.props.openConfig('Delete Group Element', inputs, [{ execute: this.getGraph, type: 'done' }]);
        } else if (manywho.utils.isEqual(selectedCell.style, 'outcome', true)) {
            inputs.id = selectedCell.source.id;
            // For some currently unknown reason sometimes for FAULT outcomes the id of the cell changes itself so look up
            // the id from the static value object instead
            inputs.outcomeId = selectedCell.value.id;
            this.props.openConfig('Delete Map Element', inputs, [{ execute: this.getGraph, type: 'done' }]);
        } else {
            inputs.id = selectedCell.id;
            inputs.elementType = selectedCell.style;
            this.props.openConfig('Delete Map Element', inputs, [{ execute: this.getGraph, type: 'done' }]);
        }

        return true;
    }

    createMapElementIcons(iconUrl, attrTitle, onClickEvent, mapNode) {
        const icon = mxUtils.createImage(iconUrl);
        icon.setAttribute('title', attrTitle);
        icon.style.cursor = 'pointer';
        icon.style.width = '16px';
        icon.style.height = '16px';

        mxEvent.addGestureListeners(icon,
            mxUtils.bind(this, (evt) => {
                // Disables dragging the image
                mxEvent.consume(evt);
            }));

        mxEvent.addListener(icon, 'click',
            mxUtils.bind(this, (evt) => {
                onClickEvent();
                mxEvent.consume(evt);
            }));

        mapNode.appendChild(icon);
    }

    closeFind() {
        this.setState({ isFindVisible: false, find: '' });
        this.updateFilteredGraph(null, null);
    }

    filterMapElementsAndOutcomes(find) {
        const filteredMapElements = this.props.graph.mapElements
            .filter(element => element.developerName.toLowerCase().indexOf(find.toLowerCase()) === -1)
            .map(element => element.id);

        const filteredOutcomes = [].concat.apply([], this.props.graph.mapElements.map(element => element.outcomes))
            .filter(outcome => outcome && outcome.developerName.toLowerCase().indexOf(find.toLowerCase()) === -1)
            .map(outcome => outcome.id);

        this.updateFilteredGraph(filteredMapElements, filteredOutcomes);
    }

    updateFilteredGraph(filteredMapElements, filteredOutcomes) {
        const model = this.graph.getModel();

        const outcomes = [].concat.apply([], (this.props.graph.mapElements || []).map((element) => {
            if (element.outcomes && element.outcomes.length > 0) {
                return element.outcomes;
            }
            return [];
        }));

        model.beginUpdate();

        try {
            (this.props.graph.mapElements || []).forEach((mapElement) => {
                let style = mapElement.elementType;

                if (style !== 'start' && filteredMapElements && filteredMapElements.indexOf(mapElement.id) !== -1) {
                    style += '_filtered';
                }

                if (!manywho.utils.isEqual(mapElement.elementType, 'START', true)) {
                    this.graph.setCellStyle(style, [model.getCell(mapElement.id)]);
                }
            });

            (outcomes || []).forEach((outcome) => {
                let style = 'outcome';

                if (filteredOutcomes && filteredOutcomes.indexOf(outcome.id) !== -1) {
                    style += '_filtered';
                }

                this.graph.setCellStyle(style, [model.getCell(outcome.id)]);
            });
        } finally {
            model.endUpdate();
        }
    }

    render() {
        if (this.props.disabled && this.state.dragSources) {
            this.state.dragSources.forEach((element) => {
                element.enabled = false;
            });
        } else if (this.state.dragSources) {
            this.state.dragSources.forEach((element) => {
                element.enabled = true;
            });
        }

        const closeFindButton = <Button bsStyle="danger" onClick={this.closeFind}><Glyphicon glyph="remove" /></Button>;
        let find = null;
        if (this.state.isFindVisible) {
            find = (
                <InputGroup className="graph-find">
                    <FormControl type="text" value={this.state.find} onChange={this.onFindChange} autoFocus />
                    <InputGroup.Button>
                        {closeFindButton}
                    </InputGroup.Button>
                </InputGroup>
            );
        }


        let disabledOverlay = null;

        if (this.props.disabled) {
            disabledOverlay = <div className="disabled" />;
        }

        return (
            <div className="graph-container">
                <div onClick={this.onClick} onWheel={this.onWheel} ref={this.props.flowId} className="graph" id={this.props.flowId}>
                    { this.props.isLoading && React.createElement(manywho.component.getByName('wait'), { isVisible: true })}
                </div>
                {find}
                {disabledOverlay}
            </div>
        );
    }
}

const mapDispatchToProps = {
    addNotification,
};

export default connect(
    ({ configPanel }) => ({ configActive: configPanel.isActive }),
    mapDispatchToProps,
)(Graph);
